import React from 'react';
import App from './App';
import './i18n';
import {
Navigate,
useRouteError,
createBrowserRouter,
createRoutesFromElements,
RouterProvider, Route
} from "react-router-dom";
import { CookiesProvider } from 'react-cookie';
import { createRoot } from 'react-dom/client';
import { CssBaseline } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material';
import Home from './src/Pages/Home/Home';
import Login from './src/Pages/BBAuthentication/Login';
import Authentication from './src/Pages/BBAuthentication/Authentication';
import TwoFactorAuth from './src/Pages/BBAuthentication/TwoFactorAuth';
import SignupAccount from './src/Pages/Register/SignupAccount';
import ForgotPwd from './src/Pages/BBAuthentication/ForgotPwd';
import SelectCompanyPlant from './src/Pages/BBAuthentication/SelectCompanyPlant';
import ResetPwd from './src/Pages/Home/ResetPwd';
import { AuthProvider } from './src/_common/AuthContext';
import Invitation from './src/Pages/Home/Invitation';


const container = document.getElementById('app');
const root = createRoot(container);

const GlobalError = () => {
const error = useRouteError();
console.log(error);

return (<div>{error}</div>);
}

const theme = createTheme({
typography: {
fontFamily: '-apple-system, BlinkMacSystemFont, "Poppins", "Segoe UI", Roboto, Helvetica, Arial, sans-serif,' +
'"Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
},
});

const router = createBrowserRouter(createRoutesFromElements(
<Route path="/" element={<App />} errorElement={
<GlobalError />}>
{/* Public Routes */}
<Route index element={<Home />} />
<Route path="login" element={<Login />} />
<Route path="resetpwd" element={<ResetPwd />} />
<Route path="invitation" element={<Invitation />} />

{/* Authentication Routes */}
<Route path="authentication" element={<Authentication />} />
<Route path="authentication/twoFactorAuth" element={<TwoFactorAuth />} />
<Route path="authentication/forgotPwd" element={<ForgotPwd />} />
<Route path="authentication/selectCompanyPlant" element={<SelectCompanyPlant />} />

{/* Registration Routes */}
<Route path="signup/signupAccount" element={<SignupAccount />} />
</Route>
));

root.render(
<ThemeProvider theme={theme}>
    <CookiesProvider>
        <AuthProvider>
            <CssBaseline />
            <RouterProvider router={router} />
        </AuthProvider>
    </CookiesProvider>
</ThemeProvider>
);
